import { useEffect, useRef, useState } from 'react';
import { MyGoogleMap } from './components/MyGoogleMap';
import styles from './index.module.scss';
import { type GoogleMapBaseProps } from './types';

type Props = GoogleMapBaseProps & {
  autoLoad?: boolean;
};

export const LazyGoogleMap = ({ width, height, markerCoordinates, mapCenterCoordinate, autoLoad = true }: Props) => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!autoLoad || isMapLoaded) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsMapLoaded(true);
          observer.disconnect();
        }
      },
      { rootMargin: '1000px 0px 0px 0px' }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [autoLoad, isMapLoaded]);

  const handleLoadMap = () => {
    setIsMapLoaded(true);
  };

  return (
    <div ref={containerRef} className={styles.base} style={{ width, height }}>
      {isMapLoaded ? (
        <MyGoogleMap
          width={width}
          height={height}
          markerCoordinates={markerCoordinates}
          mapCenterCoordinate={mapCenterCoordinate}
        />
      ) : (
        <div className={styles.placeholder}>
          {!autoLoad && (
            <button className={styles['load-button']} type="button" onClick={handleLoadMap}>
              地図を表示
            </button>
          )}
        </div>
      )}
    </div>
  );
};
